import {
  ServiceProvider,
  StageKey,
  STATUS_TYPES,
  StatusKey,
} from "../../../utils/integrationConfigData";

const STAGE_DOTS: StageKey[] = ["crd", "dtr", "pas"];

const resolveStatusKey = (status: string): StatusKey =>
  (status as StatusKey) in STATUS_TYPES ? (status as StatusKey) : "notSet";

interface ProviderListProps {
  providers: ServiceProvider[];
  selectedProviderId?: string | null;
  onSelect?: (provider: ServiceProvider) => void;
  onAddProvider?: () => void;
}

const ProviderList = ({
  providers,
  selectedProviderId,
  onSelect,
  onAddProvider,
}: ProviderListProps) => {
  return (
    <aside className="ic-provider-list" aria-label="Service providers">
      <div className="ic-provider-list-header">
        <div className="ic-provider-list-label">Service Providers</div>
        <button
          type="button"
          className="ic-add-provider-btn"
          onClick={onAddProvider}
          aria-label="Add provider"
          title="Add provider"
        >
          <i className="fh_add" aria-hidden="true"></i>
        </button>
      </div>

      <div className="ic-provider-list-items">
        {providers.map((provider) => {
          const isActive = provider.id === selectedProviderId;

          return (
            <button
              key={provider.id}
              type="button"
              className={`ic-provider-list-item ${isActive ? "active" : ""}`}
              onClick={() => onSelect?.(provider)}
            >
              <div className="ic-provider-list-main">
                <div className="ic-provider-list-name">
                  {provider.shortName || provider.name}
                </div>
                <div className="ic-provider-list-count">
                  {provider.cptCodes}
                </div>
              </div>
              <div className="ic-provider-list-dots" aria-hidden="true">
                {STAGE_DOTS.map((stageKey) => {
                  const statusKey = resolveStatusKey(provider[stageKey]);
                  const tone = STATUS_TYPES[statusKey].tone;

                  return (
                    <span
                      key={stageKey}
                      className={`ic-stage-dot ic-stage-dot--${tone} ic-stage-dot--${statusKey}`}
                      title={`${stageKey.toUpperCase()}: ${STATUS_TYPES[statusKey].label}`}
                    />
                  );
                })}
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
};

export default ProviderList;
